import { render, staticRenderFns } from "./rateHistoryVersion.vue?vue&type=template&id=1561ecd4"
import script from "./rateHistoryVersion.vue?vue&type=script&lang=js"
export * from "./rateHistoryVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1561ecd4')) {
      api.createRecord('1561ecd4', component.options)
    } else {
      api.reload('1561ecd4', component.options)
    }
    module.hot.accept("./rateHistoryVersion.vue?vue&type=template&id=1561ecd4", function () {
      api.rerender('1561ecd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/QBR/rateHistoryVersion.vue"
export default component.exports